import size from "../sizes";
import image11 from "../../assets/images/materials/classic-tee/11.jpg";
import image12 from "../../assets/images/materials/classic-tee/12.jpg";
import image13 from "../../assets/images/materials/classic-tee/13.jpg";
import image14 from "../../assets/images/materials/classic-tee/14.jpg";
import image15 from "../../assets/images/materials/classic-tee/15.jpg";
import image16 from "../../assets/images/materials/classic-tee/16.jpg";
import image17 from "../../assets/images/materials/classic-tee/17.jpg";
import image18 from "../../assets/images/materials/classic-tee/18.jpg";
import image19 from "../../assets/images/materials/classic-tee/19.jpg";
import image20 from "../../assets/images/materials/classic-tee/20.jpg";
import image21 from "../../assets/images/materials/classic-tee/21.jpg";
import image22 from "../../assets/images/materials/classic-tee/22.jpg";
import image23 from "../../assets/images/materials/classic-tee/23.jpg";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Классическая футболка с коротким рукавом и круглым воротом, отделанным трикотажной резинкой. Хлопок высокой плотности (от 155гр/м<sup>2</sup> до 200гр/м<sup>2</sup>) и прочное крашение гарантирует устойчивость к стиркам, выцветанию и потере формы. Качественный материал обеспечивает комфортную носку и не вызывает аллергических реакций.</p>`,
      images: [
        {
          source: image14,
          captionContent: {
            title: `Качественные лицевые швы`,
            description: `Лицевые швы на футболках ровные и аккуратные: ткань не морщит и не тянет при носке. Мы соблюдаем технологию раскроя ткани, поэтому швы на футболках не растягиваются, а сами футболки не перекручиваются.`
          }
        },
        {
          source: image11,
          captionContent: {
            title: `Эластичная горловина`,
            description: `Горловина на футболках шьется из качественной рибаны — эластичной ткани в мелкую резинку. Такая горловина отличается прочностью, долго держит форму и не растягивается от регулярной носки.`
          }
        },
        {
          source: image15,
          captionContent: {
            title: `Эстетичные внутренние швы`,
            description: `Внутренние края на футболках обрабатываются широким плоским швом. Поэтому даже после многочисленных стирок ткань не мохрится и не деформируется, а из швов не торчат нитки.`
          }
        },
        {
          source: image12,
          captionContent: {
            title: `Минималистичный дизайн`,
            description: `Все швы выполнены нитями в тон ткани, поэтому футболки выглядят стильно и минималистично. Контроль качества на производстве позволяет добиться равномерной строчки и одинаковых подгибов ткани, поэтому наши футболки выглядят значительно лучше, чем аналогичные из масс-маркета.`
          }
        },
        {
          source: image22,
          captionContent: {
            title: `Принты высокого разрешения`,
            description: `Мы печатаем ваши дизайны на современном оборудовании, поэтому наши принты получаются яркими и не выцветают даже после многочисленных стирок. Мы контролируем процесс на всех этапах — от качества загружаемого изображения до закрепления красителя на ткани, — чтобы вы остались довольны полученным результатом.`
          }
        },
        {
          source: image21,
          captionContent: {
            title: `Комфортная посадка`,
            description: `Наши футболки одинаково хорошо сидят на разных фигурах. Слегка свободный крой футболки не стесняет движений и делает ее комфортной в носке.`
          }
        },
        {
          source: image18,
          captionContent: {
            title: `Большой выбор цветов`,
            description: `Яркие насыщенные цвета футболок достигаются с помощью окрашивания нитей активными красителями. Благодаря такой технологии футболка не выцветает и не теряет яркости даже после 50 стирок.`
          }
        },
        {
          source: image19,
          captionContent: {
            title: `Натуральные ткани`,
            description: `Наши футболки производятся из плотного 100% хлопка, приятного к телу. Такие футболки комфортны в носке в любую погоду: натуральная ткань пропускает влагу, позволяя коже дышать.`
          }
        },
        {
          source: image17,
          captionContent: {
            title: `Классические цвета футболок`,
            description: `Ищете идеальную белую футболку с правильной посадкой не по цене самолета? У нас есть то, что вам нужно. Идеальные базовые футболки белого, черного и серого цвета (меланж) превосходно смотрятся и с дизайном, и просто так.`
          }
        },
        {
          source: image16,
          captionContent: {
            title: `Истинный чёрный`,
            description: `Наши чёрные футболки отличаются насыщенным цветом, который не выцветает и не бледнеет даже после многочисленных стирок. Благодаря ткани высокой плотности футболки не просвечивают, не скатываются и хорошо держат форму.`
          }
        },
        {
          source: image13,
          captionContent: {
            title: `Серый меланж`,
            description: `Серые футболки мы производим из меланжевого хлопка — натуральной ткани из нитей нескольких цветов. Получается уникальный рисунок ткани, который служит отличной основой для красочных принтов.`
          }
        },
        {
          source: image20,
          captionContent: {
            title: `Как ухаживать за футболкой`,
            description: `Перед стиркой вывернуть футболку наизнанку и стирать с вещами, близкими по цвету, при температуре до 40°С на щадящем режиме. Не отбеливать. Гладить с изнанки при температуре до 150°С. Не сушить в барабане и не подвергать химчистке.`
          }
        },
        {
          source: image23,
          captionContent: {
            title: `Свободный крой`,
            description: `Мужская футболка стильно выглядит даже на женской фигуре`
          }
        }
      ]
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`classic_tee`],
      sizeInfo: `classic_tee`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `reviews`,
    title: `Отзывы`
  },
  {
    id: `description`,
    title: `Описание`,
    hideOnMobile: true,
    content: {
      description: `<p>Printio – это быстрая и качественная печать футболок с логотипом, надписью или фото на заказ. Нанесем картинку из каталога, либо сделаем печать по индивидуальному рисунку. Сделать футболку со своим дизайном можно при помощи онлайн конструктора. Срок нанесения надписи, логотипа или принта на футболку или майку в Москве, в зависимости от объема печати - 1-2 дня.</p>`
    }
  }
];
